import React, { useEffect, useState, useRef } from "react";

import "../../styles/aboutUs/vision_mission.scss";

const VisionMissionComponent = ({}) => {
  return (
    <>
      <div className="aboutUs-wrapper">
        <h2 className="aboutUs-heading">About Us</h2>
        <div className="aboutUs-content">
          Driven by innovation and fueled by passion, Wizzgeeks is a team of
          forward-thinking minds dedicated to transforming businesses through
          cutting-edge digital solutions. What started as a vision among a few
          tech enthusiasts has evolved into a full-fledged IT services company
          known for its commitment to excellence and a future-first approach.
        </div>
      </div>
      <div className="aboutUs-vision-mission-wrapper">
        <div className="aboutUs-vision-wrapper width-50">
          <div className="aboutUs-vision-mission-heading">Vision</div>
          <div className="aboutUs-vision-mission-content">
            To make a mark in the global market by delivering cutting-edge
            software solutions that enhance business efficiency and user
            experience.{" "}
          </div>
        </div>
        <div className="aboutUs-border"></div>
        <div className="aboutUs-mission-wrapper width-50">
          <div className="aboutUs-vision-mission-heading">Mission</div>
          <div className="aboutUs-vision-mission-content">
            We explore and embrace the latest technologies, fostering continuous
            learning and innovation. We take on experimental projects to push
            boundaries, discover new possibilities, and create impactful
            solutions
          </div>
        </div>
      </div>
    </>
  );
};

export default VisionMissionComponent;
